import React from 'react'

import { NewFeatureHighlightPopover } from '@sketch/components'

const popoverTexts = {
  profile: {
    admin: {
      title: 'Share Your Work With Everyone',
      body: 'Add documents to your public profile to share your best work and resources with the world.',
      button: undefined,
    },
    noAdmin: {
      title: 'Share Your Work With Everyone',
      body: 'Add documents to your public profile to share your best work and resources with the world.',
      button: undefined,
    },
  },
  noProfile: {
    admin: {
      title: 'Share your work with everyone',
      body: 'Create a public profile to showcase your best work and share resources with the world.',
      button: 'Get Started',
    },
    noAdmin: {
      title: 'A Space for Your Best Work',
      body: 'With a public profile you can showcase your best work and share resources with the world. Ask an admin to create one!',
      button: undefined,
    },
  },
}

interface Props {
  isAdmin: boolean
  show: boolean
  isProfileCreated: boolean
  onConfirm?: () => void
}

export const PopoverInfo = ({
  isAdmin,
  isProfileCreated,
  onConfirm,
  show,
}: Props) => {
  const profileKey: keyof typeof popoverTexts = isProfileCreated
    ? 'profile'
    : 'noProfile'

  const adminKey: keyof (typeof popoverTexts)['profile'] = isAdmin
    ? 'admin'
    : 'noAdmin'

  const title = popoverTexts[profileKey][adminKey].title
  const body = popoverTexts[profileKey][adminKey].body
  const button = popoverTexts[profileKey][adminKey].button
  const onConfirmHandler = () => {
    if (button) {
      onConfirm?.()
    }

    return undefined
  }

  return (
    <NewFeatureHighlightPopover
      highlightPlacement="sidebar"
      placement="right"
      titleText={title}
      bodyText={body}
      confirmCopy={button}
      onConfirm={onConfirmHandler}
      localStorageKey="publicProfilePopoverSeen"
      show={show}
    />
  )
}
